'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ('value' in descriptor)
                descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function (Constructor, protoProps, staticProps) {
        if (protoProps)
            defineProperties(Constructor.prototype, protoProps);
        if (staticProps)
            defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
var _utils = require('./utils');
var _utils2 = _interopRequireDefault(_utils);
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError('Cannot call a class as a function');
    }
}
var Timer = function () {
    function Timer(player) {
        _classCallCheck(this, Timer);
        this.player = player;
        window.requestAnimationFrame = function () {
            return window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || window.oRequestAnimationFrame || window.msRequestAnimationFrame || function (callback) {
                window.setTimeout(callback, 1000 / 60);
            };
        }();
        this.types = [
            'loading',
            'progress'
        ];
        this.init();
    }
    _createClass(Timer, [
        {
            key: 'init',
            value: function init() {
                var _this = this;
                this.types.map(function (item) {
                    _this['init' + item + 'Checker']();
                    return item;
                });
            }
        },
        {
            key: 'initprogressChecker',
            value: function initprogressChecker() {
                var _this2 = this;
                this.progressChecker = setInterval(function () {
                    if (_this2.enableprogressChecker) {
                        _this2.player.bar.set('played', _this2.player.audio.currentTime / _this2.player.audio.duration, 'width');
                        _this2.player.lrc && _this2.player.lrc.update();
                        var currentTime = _utils2.default.secondToTime(_this2.player.audio.currentTime);
                        if (_this2.player.template.ptime.innerHTML !== currentTime) {
                            _this2.player.template.ptime.innerHTML = currentTime;
                        }
                    }
                }, 100);
            }
        },
        {
            key: 'initloadingChecker',
            value: function initloadingChecker() {
                var _this3 = this;
                var lastPlayPos = 0;
                var currentPlayPos = 0;
                var bufferingDetected = false;
                this.loadingChecker = setInterval(function () {
                    if (_this3.enableloadingChecker) {
                        currentPlayPos = _this3.player.audio.currentTime;
                        if (!bufferingDetected && currentPlayPos === lastPlayPos && !_this3.player.audio.paused) {
                            _this3.player.container.classList.add('aplayer-loading');
                            bufferingDetected = true;
                        }
                        if (bufferingDetected && currentPlayPos > lastPlayPos && !_this3.player.audio.paused) {
                            _this3.player.container.classList.remove('aplayer-loading');
                            bufferingDetected = false;
                        }
                        lastPlayPos = currentPlayPos;
                    }
                }, 100);
            }
        },
        {
            key: 'enable',
            value: function enable(type) {
                this['enable' + type + 'Checker'] = true;
                if (type === 'fps') {
                    this.initfpsChecker();
                }
            }
        },
        {
            key: 'disable',
            value: function disable(type) {
                this['enable' + type + 'Checker'] = false;
            }
        },
        {
            key: 'destroy',
            value: function destroy() {
                var _this4 = this;
                this.types.map(function (item) {
                    _this4['enable' + item + 'Checker'] = false;
                    _this4[item + 'Checker'] && clearInterval(_this4[item + 'Checker']);
                    return item;
                });
            }
        }
    ]);
    return Timer;
}();
exports.default = Timer;


//////////////////
// WEBPACK FOOTER
// ./src/js/timer.js
// module id = 33
// module chunks = 0